<template>
  <div
    id="pdf-content-div"
  >
    <order-preview-basic
      :oid="printData.Oid"
      :show-actions="false"
    />
    <v-card
      class="mx-auto mt-5 order-form-vcard"
    >
      <v-card-text class="order-form-vcard-text">
        <v-form
          id="order-form"
          ref="orderForm"
        >
          <v-item-group class="form-section customer-details">
            <div
              class="form-section-header"
            >
              Billing Details
            </div>
            <v-expand-transition>
              <div
                class="form-section-body-wrapper"
              >
                <div
                  class="form-section-body"
                >
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.ClientName"
                      label="Company Name"
                      disabled
                    />
                    <v-text-field
                      v-model="printData.ClientDescription"
                      label="Company Description"
                      disabled
                    />
                  </v-item-group>
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.ClientVatNo"
                      label="Vat Number"
                      disabled
                    />
                    <v-text-field
                      v-model="printData.ClientTaxAuthority"
                      label="Tax Activity"
                      disabled
                    />
                    <v-text-field
                      v-model="printData.ClientCountry.DisplayName"
                      label="Country"
                      disabled
                    />
                  </v-item-group>
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.ClientTelephone"
                      label="Telephone"
                      disabled
                    />
                    <v-text-field
                      v-model="printData.ClientEmail"
                      label="Email to receive invoice"
                      disabled
                    />
                  </v-item-group>
                </div>
              </div>
            </v-expand-transition>
          </v-item-group>
          <v-item-group class="form-section address address-from">
            <div
              class="form-section-header"
            >
              Ship Form (Pickup Address)
            </div>
            <v-expand-transition>
              <div
                class="form-section-body-wrapper"
              >
                <div
                  class="form-section-body"
                >
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.AddressFrom.AddressDetails"
                      label="Street Name/Number"
                      disabled
                    />

                    <v-text-field
                      v-model="printData.AddressFrom.City"
                      label="City"
                      disabled
                    />
                  </v-item-group>
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.AddressFrom.PostCode"
                      label="Postal Code"
                      disabled
                    />
                    <v-text-field
                      v-model="printData.AddressFrom.Country.DisplayName"
                      label="Country From"
                      disabled
                    />
                  </v-item-group>
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.AddressFrom.ContactPerson"
                      label="Contact Person"
                      disabled
                    />

                    <v-text-field
                      v-model="printData.AddressFrom.Email"
                      label="Email"
                      append-icon="mdi-email"
                      disabled
                    />

                    <v-text-field
                      v-model="printData.AddressFrom.Telephone"
                      label="Telephone"
                      append-icon="mdi-phone"
                      required
                    />
                  </v-item-group>
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.PickUpReference"
                      label="Pick Up Reference"
                      required
                    />
                    <v-text-field
                      v-model="printData.OnBehalfOf"
                      label="On Behalf Of"
                      required
                    />
                  </v-item-group>
                  <v-item-group class="fields-group datetime-group">
                    <time-picker
                      v-model="printData.AddressFrom.WorkingHoursFrom"
                      :init-value="printData.AddressFrom.WorkingHoursFrom"
                      label="Working hours From"
                      :read-only="true"
                      :force-no-opaque="true"
                    />
                    <time-picker
                      v-model="printData.AddressFrom.WorkingHoursTo"
                      :init-value="printData.AddressFrom.WorkingHoursTo"
                      label="Working hours To"
                      :read-only="true"
                      :force-no-opaque="true"
                    />
                    <date-picker
                      v-model="printData.PickUpDate"
                      :init-value="printData.PickUpDate"
                      label="Pickup Date"
                      :read-only="true"
                      :force-no-opaque="true"
                    />
                  </v-item-group>
                </div>
              </div>
            </v-expand-transition>
          </v-item-group>
          <v-item-group class="form-section address address-to">
            <div
              class="form-section-header"
            >
              Ship To (Delivery Address)
            </div>
            <v-expand-transition>
              <div
                class="form-section-body-wrapper"
              >
                <div
                  class="form-section-body"
                >
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.AddressTo.AddressDetails"
                      label="Street Name/Number"
                      disabled
                    />

                    <v-text-field
                      v-model="printData.AddressTo.City"
                      label="City"
                      disabled
                    />
                  </v-item-group>
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.AddressTo.PostCode"
                      label="Postal Code"
                      disabled
                    />
                    <v-text-field
                      v-model="printData.AddressTo.Country.DisplayName"
                      label="Country To"
                      disabled
                    />
                  </v-item-group>
                  <v-item-group class="fields-group">
                    <v-text-field
                      v-model="printData.AddressTo.ContactPerson"
                      label="Contact Person"
                      disabled
                    />

                    <v-text-field
                      v-model="printData.AddressTo.Email"
                      label="Email"
                      append-icon="mdi-email"
                      disabled
                    />

                    <v-text-field
                      v-model="printData.AddressTo.Telephone"
                      label="Telephone"
                      append-icon="mdi-phone"
                      required
                    />
                  </v-item-group>
                  <v-item-group class="fields-group datetime-group">
                    <time-picker
                      v-model="printData.AddressTo.WorkingHoursFrom"
                      :init-value="printData.AddressTo.WorkingHoursFrom"
                      label="Working hours From"
                      :read-only="true"
                      :force-no-opaque="true"
                    />
                    <time-picker
                      v-model="printData.AddressTo.WorkingHoursFrom"
                      :init-value="printData.AddressTo.WorkingHoursFrom"
                      label="Working hours To"
                      :read-only="true"
                      :force-no-opaque="true"
                    />
                  </v-item-group>
                </div>
              </div>
            </v-expand-transition>
          </v-item-group>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import OrderPreviewBasic from '@/components/OrderPreviewBasic.vue'
  import { helperFunctions } from '@/store/helpers'

  export default {
    name: 'OrderPrint',
    components: {
      OrderPreviewBasic,
    },
    props: {
      printData: {
        type: Object,
        required: false,
      },
    },
    created () {
      this.printData.AddressFrom.WorkingHoursFrom = helperFunctions.decodeTimeFromApi(this.printData.AddressFrom.WorkingHoursFrom)
      this.printData.AddressFrom.WorkingHoursTo = helperFunctions.decodeTimeFromApi(this.printData.AddressFrom.WorkingHoursTo)
      this.printData.PickUpDate = helperFunctions.decodeDateFromApi(this.printData.PickUpDate)
      this.printData.AddressTo.WorkingHoursFrom = helperFunctions.decodeTimeFromApi(this.printData.AddressTo.WorkingHoursFrom)
      this.printData.AddressTo.WorkingHoursTo = helperFunctions.decodeTimeFromApi(this.printData.AddressTo.WorkingHoursTo)
    },
  }
</script>

<style lang="scss" scoped>
#pdf-content-div {
  background-color: #fff !important;
  padding-right: 30px;
  box-sizing: border-box;
  margin: 20px auto;
  width: 90%;

  .printer-link{
    display: none !important;
  }
}
</style>
<style lang="scss" >
#pdf-content-div {
  background-color: #fff !important;
  .preview-card{
    background-color: #fff !important;
    .printer-link{
      display: none !important;
    }
    .price-wrapper{
      background-color: #fff !important;
    }
    .v-card__text {
      background-color: #fff !important;
      .basic-info, .items-wrapper{
        background-color: #fff !important;
      }
    }
  }
  line-height: 18px;
}
</style>
<style lang="scss" scoped>
#order-view-content{
  max-width: 750px;
  .v-input--is-disabled {
    opacity: 1 !important;
  }
}
.order-form-vcard{
  background-color: rgba(255, 255, 255, 0);
  box-shadow: none !important;
  margin-top: 0 !important;
  margin-left: 0 !important;
  .order-form-vcard-text{
    padding: 0;
    .v-item-group{
      padding: 5px 0;
      &.form-section{
        background-color: $bgWhite09;
        padding: 0;
        margin-top: 5px;

        .form-section-body{
          padding: 20px;
        }

        .form-section-header{
          background-color: $goldairLightBlue2;
          padding: 5px 20px;
          box-sizing: content-box;
          color: #fff;
          font-weight: 400;
          font-size: 15px;
          cursor: pointer;
        }

        .fields-group{
          display: flex;
          &:not(.address-selection){
            .v-text-field{
              width: 50%;
              max-width: 50%;
            }
          }
          .v-input:not(:last-child){
            margin-right: 30px;
          }
          &.address-selection{
            padding: 0 !important;
          }
          &.datetime-group{
            padding-top: 0;
            input{
              cursor: default !important;
            }
            >.row{
              padding: 0;
              margin: 0;
              .col{
                padding: 0 !important;
              }
            }
          }
        }
      }
      &.item-section{
        margin-bottom: 20px;
      }
      .address-group{
        display: flex;
        flex-direction: row;
        .v-select, .v-input:first-child{
          padding-right: 10px;
        }
      }
    }
  }
  .v-card__actions{
    padding: 20px;
    background-color: #fff;
  }
}
</style>
